import React from 'react';
import axios from 'axios';
import { render, screen, act} from '@testing-library/react';
import '@testing-library/jest-dom';
import PurchaseComplete from './purchase_complete';

jest.mock('axios');
performance.getEntriesByType = jest.fn().mockReturnValue([{type: "test"}]);

describe('PurchaseComplete', () => {
  test('renders PurchaseComplete component', async() => {

    const purchase = Promise.resolve({ data: { total_fee: 10000, m_company_id: 1} });

    (axios.post as any).mockResolvedValue(purchase);
    await act(() => purchase);
    act(() => {
      render(<PurchaseComplete total_fee={10000} company_id={1} ticket={[]}/>);
    });

    

    // screen.debug();
    expect(screen.getByText(/0/)).toBeInTheDocument();
    expect(screen.getByText('チケットを購入しました。')).toBeInTheDocument();
  });
});
